import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./Login";
import EmpresasManager from "./components/EmpresasManager";
import UsuariosManager from "./components/UsuariosManager";
import EmpleadosManager from "./components/EmpleadosManager";
import EvaluacionesManager from "./components/EvaluacionesManager";
import InformesManager from "./components/InformesManager";
import ReportesManager from "./components/ReportesManager";
import ConfiguracionManager from "./components/ConfiguracionManager";
import AdminDashboard from "./components/AdminDashboard";
import EmpleadoDashboard from "./components/EmpleadoDashboard";
import PsicologoDashboard from "./components/PsicologoDashboard";
import RRHHDashboard from "./components/RRHHDashboard";
import "./styles/global.css";

function PrivateRoute({ children }) {
  const [user, setUser] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [empleadoSession, setEmpleadoSession] = React.useState(null);

  React.useEffect(() => {
    // Verificar autenticación Firebase
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      console.log('🔍 Firebase user state changed:', firebaseUser ? firebaseUser.email : 'null');
      setUser(firebaseUser);
      setLoading(false);
    });

    // Verificar sesión de empleado
    const empleadoData = localStorage.getItem('empleadoSession');
    if (empleadoData) {
      try {
        const parsedData = JSON.parse(empleadoData);
        console.log('🔍 Empleado session found:', parsedData.nombre);
        setEmpleadoSession(parsedData);
      } catch (error) {
        console.error('Error parsing empleado session:', error);
        localStorage.removeItem('empleadoSession');
      }
    } else {
      console.log('🔍 No empleado session found');
    }

    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1e40af, #3b82f6)'
      }}>
        <div style={{
          background: 'white',
          padding: '24px',
          borderRadius: '12px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #1e40af',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <p style={{ color: '#64748b', margin: 0 }}>Cargando...</p>
        </div>
      </div>
    );
  }

  console.log('🔍 PrivateRoute - User:', user ? user.email : 'null', 'EmpleadoSession:', empleadoSession ? empleadoSession.nombre : 'null');

  // Si hay sesión de empleado, solo permitir acceso a rutas de empleado
  if (empleadoSession && window.location.pathname !== '/dashboard-empleado') {
    console.log('🔄 Redirecting empleado to dashboard-empleado');
    return <Navigate to="/dashboard-empleado" />;
  }
  
  // Si hay usuario Firebase o sesión de empleado, permitir acceso
  if (user || empleadoSession) {
    console.log('✅ Access granted - User authenticated');
    return children;
  }
  
  // Si no hay ninguna sesión activa, redirigir al login
  console.log('🔄 No authentication found - Redirecting to login');
  return <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard-empleado"
          element={
            <PrivateRoute>
              <EmpleadoDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/empresas"
          element={
            <PrivateRoute>
              <EmpresasManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/usuarios"
          element={
            <PrivateRoute>
              <UsuariosManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/empleados"
          element={
            <PrivateRoute>
              <EmpleadosManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/evaluaciones"
          element={
            <PrivateRoute>
              <EvaluacionesManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/rrhh"
          element={
            <PrivateRoute>
              <RRHHDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/psicologo"
          element={
            <PrivateRoute>
              <PsicologoDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/informes"
          element={
            <PrivateRoute>
              <InformesManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/reportes"
          element={
            <PrivateRoute>
              <ReportesManager />
            </PrivateRoute>
          }
        />
        <Route
          path="/configuracion"
          element={
            <PrivateRoute>
              <ConfiguracionManager />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
